import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/processes/')({
  loader: () => {
    throw redirect({
      to: '/processes/pipelines',
    })
  },
})
